import React from 'react';
import PropTypes from "prop-types";
import { getAccessToken } from '../services/local_storage_service';
import { Route, Redirect } from 'react-router-dom';
import { REACT_ROUTES } from '../constants/react_routes';

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <Route {...rest} render={(props) => (
        getAccessToken()
            ?
            <Layout>
                <Component {...props} />
            </Layout>
            :
            <Redirect to={REACT_ROUTES.HOME} />
    )} />
);

PrivateRoute.propTypes = {
    component: PropTypes.elementType,
    layout: PropTypes.elementType
};

export default PrivateRoute;
